<script lang="ts">
    import PageWrapper from '$lib/components/_page/PageWrapper.svelte';
    import Layout from '$lib/components/_page/Layout.svelte';

    let {
        children,
        data,
    } = $props()

    const {
        setup,
        loggedIn
    } = data;
</script>

<Layout
        setup={setup}
        awaitSetup={false}
        loggedIn={loggedIn.current}
>
    {#snippet page()}
        <PageWrapper
                footer={true}
                pageMaxWidth={1120}
        >

            {@render children()}
        </PageWrapper>
    {/snippet}
</Layout>
